import { useEffect, useState, useCallback } from 'react';
import useQueryString from '../queryString/useQueryString';
import useUser from '../user/useUser';

// Service
import SearchProductsService from '../../services/searchProductsService';
import useNotify from '../notify';
import { utils } from '../../utils/utils';

const initialFilters = {
    pageSize: 20,
    page: 1,
    code: '',
    categoryIds: '',
    searchData: '',
    withStockInBranch: true
}

const useSearchProducts = () => {
    const [searchResult, setSearchResult] = useState({
        searchProducts: [],
        totalPage: 0,
        totalResult: 0
    })
    const { filters, setParameterSearch } = useQueryString(initialFilters);
    const { branch } = useUser();
    const [loading, setLoading] = useState(true);
    const [exportLoading, setExportLoading] = useState(false);
    const { Notify, variants } = useNotify();

    useEffect(() => {
        const FindSearchProducts = () => {
            setLoading(true);
            SearchProductsService
                .Search({ ...filters, branchCode: branch.code, country: branch.country })
                .then(res => setSearchResult({
                    searchProducts: res.result,
                    totalResult: res.found,
                    totalPage: Math.ceil(res.found / filters.pageSize)
                }))
                .finally(() => setLoading(false));
        }

        if (branch && branch.code)
            FindSearchProducts();
    }, [filters, branch])

    const setFilters = useCallback((newFilter) =>
        setParameterSearch(newFilter)
    , [setParameterSearch])

    const exportProducts = async () => {
        setExportLoading(true);
        SearchProductsService.Export({ ...filters, branchCode: branch.code, country: branch.country, withStockInBranch: false })
            .then(blob => utils.export(blob, 'Catalogo'))
            .catch(() => Notify('Ocurrio un problema al intentar exportar el catálogo.', variants.ERROR))
            .finally(() => setExportLoading(false));
    }

    return {
        ...searchResult,
        filters,
        setFilters,
        loading,
        setLoading,
        exportProducts,
        exportLoading
    }
}

export default useSearchProducts;